import axios from 'axios';
import { toDefaultRequestTransforms, toDefaultResponseTransforms } from '@peloton/api/client-transforms';
import { ApiEnvs, toExtLinkEnv, toHref, toApiLink } from '@peloton/external-links/models';
import { BaseAPI } from '@engage/api-v2';
import { toApiEnv } from '@engage/env/api';
var apiEnv = typeof window === 'undefined' ? ApiEnvs.Prod : toApiEnv(window.location.hostname, function () {
  var _process$env$API_ENV;

  return (_process$env$API_ENV = process.env.API_ENV) !== null && _process$env$API_ENV !== void 0 ? _process$env$API_ENV : null;
});
var extLink = toExtLinkEnv({
  api: apiEnv
}); // REMOVE THIS WHEN SWAGGER DOCS ARE UPDATED

var apiClient = axios.create({
  baseURL: toHref(toApiLink('/'), extLink),
  responseType: 'json',
  withCredentials: true,
  transformRequest: toDefaultRequestTransforms(),
  transformResponse: toDefaultResponseTransforms()
});

var toPresenceBaseURL = function toPresenceBaseURL(apiEnv1) {
  var url = function url(env) {
    return "https://presence-leaderboard.".concat(env, ".k8s.onepeloton.com");
  };

  switch (apiEnv1) {
    case ApiEnvs.Qa1:
      return url('stage');

    case ApiEnvs.Qa2:
      return url('test');

    case ApiEnvs.Prod:
    default:
      return url('prod');
  }
};

var presenceApiClient = axios.create({
  baseURL: toPresenceBaseURL(apiEnv),
  responseType: 'json',
  withCredentials: true,
  transformRequest: toDefaultRequestTransforms(),
  transformResponse: toDefaultResponseTransforms()
});

var toPagesBaseURL = function toPagesBaseURL() {
  //TODO - make this accept all diff environments later
  return "https://api-pages.stage.k8s.onepeloton.com";
};

var pagesApiClient = axios.create({
  baseURL: toPagesBaseURL(),
  responseType: 'json',
  withCredentials: true,
  transformRequest: toDefaultRequestTransforms(),
  transformResponse: toDefaultResponseTransforms()
});
var engageApi = new BaseAPI(apiClient);
var presenceApi = new BaseAPI(presenceApiClient);
var pagesApi = new BaseAPI(pagesApiClient);
export { engageApi, presenceApi, pagesApi };